import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import get from 'lodash/get';
import { COUNT_TABLE_RECORDS } from 'constants/constants';
import {
  HypoNoeApiRequestsDocument,
  type HypoNoeApiRequestsQuery,
} from 'graphql/generated/graphql';
import type { TListItem } from 'graphql/types';

/** The requests of a page (the schema allows a null list). */
export type THypoNoeApiRequests = NonNullable<
  HypoNoeApiRequestsQuery['hypoNoeApiRequests']
>['requests'];

export type THypoNoeApiRequest = TListItem<THypoNoeApiRequests>;

const useGetHypoNoeApiRequests = ({
  currentPage,
  filter,
}: {
  currentPage: number;
  filter: string;
}) => {
  const { data, loading } = useQuery(HypoNoeApiRequestsDocument, {
    variables: {
      filter,
      offset: COUNT_TABLE_RECORDS * (currentPage - 1),
      limit: COUNT_TABLE_RECORDS,
    },
  });

  const requests = useMemo(() => {
    const noRequests: THypoNoeApiRequests = [];
    return get(data, 'hypoNoeApiRequests.requests', noRequests);
  }, [data]);
  const total = get(data, 'hypoNoeApiRequests.count', 0);

  return { requests, total, loading };
};

export default useGetHypoNoeApiRequests;
